export function millisecondsUntil(date) {
  const now = new Date();
  const futureDate = new Date(date);
  return futureDate - now;
}